<template>
	<div id="validation-summary">
		<p id="title">
			{{microcopy?.validationHeading}}
		</p>
		<p id="main-text">
            {{microcopy?.validationSummary}}
		</p>
	</div>
</template>
<script>
export default {
    data() {
        return {
            microcopy: ''
        }
    },
    mounted() {
		this.microcopy = window.bookAnAppointmentReferralMicrocopy?.existingCustomer;

    }
}
</script>

<style lang="scss" scoped>
$error: #d72d41;
$background: #fefafb;
#title {
    padding-top: 20px;
    color: $error;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 25px;
    text-align: left;
    margin-bottom: 4px;
}

#main-text {
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
    padding-bottom: 20px;
}

#validation-summary {
    border: 2px solid $error;
    border-radius: 10px;
    background-color: $background;
    max-width: 372px;
    padding-left: 24px;
    padding-right: 24px;
    margin-top: 24px;
    margin-bottom: 24px;
}
@media screen and (max-width: 600px) {
    #validation-summary {
        margin-top: 0px;
  }
}
</style>
